import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface BarChartIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const BarChartIcon: React.FC<BarChartIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon bar-chart')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512">
        <path d="M128 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64C160 398.3 145.7 384 128 384zM112 464h-32v-32h32V464zM280 256h-64c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V288C312 270.3 297.7 256 280 256zM264 464h-32v-160h32V464zM584 0h-64c-17.67 0-32 14.33-32 32v448c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V32C616 14.33 601.7 0 584 0zM568 464h-32v-416h32V464zM432 128h-64c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160C464 142.3 449.7 128 432 128zM416 464h-32v-288h32V464z" />
      </svg>
    </Tooltip>
  );
};
